import apiService from './services/ApiService';
import storeManager from './store/StoreManager';
import { loadOldProduction, loadNewProduction, loadAudioProduction, changeMode, contentXMLLoaded } from './actions/ProductionActions';
import { setCurrentSlide } from './actions/CurrentSlideActions';
import { showMenu } from './actions/MenuActions';
import zipLoader from './components/accordion/clipartUtils/ZipLoader';
import sessionActions from './actions/SessionActions';
import modeType from './constants/ModeConstants';
import configuration from './constants/Configuration';
import appParameters from './components/utils/AppParameters';
import newProductionData from '../docs/newProduction';
import audioProduction from '../docs/audioProduction';
import apiServiceUtils from './components/utils/ApiServiceUtils';
import sessionUtils from './components/utils/SessionUtils';
import menuType from './constants/MenuType';
import audioUtils from './components/utils/AudioUtils';
import playController from './components/utils/PlayController';
import audioToolUtils from './components/audioTool/utils/AudioToolUtils';
import audioVolumeUtils from './components/utils/AudioVolumeUtils';
import localesManager from './locales/LocalesManager';

const dataLoader = {
    loadData() {
        if (audioToolUtils.isAudioPlayer())
            audioVolumeUtils.addEventListener();

        this.getParametersAndLoadCaptions();

        // if (appParameters.currentUserId === 54719315 && appParameters.isMaster) { // PROD aleks2 user ... when open a master Cartoonist then the hardcoded production will be loaded
        //     this.loadInitialMockData(true);
        //     return;
        // }

        if (configuration.LOAD_LOCAL) {
            this.loadInitialMockData();
        } else {
            this.loadInitialData();
        }
    },
    getParametersAndLoadCaptions() {
        localesManager.init();

        if (!sessionUtils.parametersLoaded)
            appParameters.getParameters();

        if (appParameters.isPrintMode() || sessionUtils.isLoginWithToken())
            return;

        if (appParameters.context == modeType.EXPORT_PLAYER || appParameters.context == modeType.EXPORT_AUDIO_PLAYER) {
            return;
        }

        this.setMode();
    },
    setMode() {
        const store = storeManager.getStore();

        if (audioToolUtils.isAudioTool()) {
            if (appParameters.getMode() == modeType.AUDIO_TOOL) {
                apiServiceUtils.initLostSessionTimer(); // available only for EDITOR tools
            }

            return;
        }

        if (appParameters.getMode() == modeType.EDITOR) {
            store.dispatch(changeMode(modeType.EDITOR));
            store.dispatch(showMenu(menuType.UNIVERSES_MENU));

            apiServiceUtils.initLostSessionTimer();
        } else
            store.dispatch(changeMode(modeType.PLAYER));
    },
    loadInitialMockData(forceBlankProduction = false) {
        const store = storeManager.getStore();
        var xmlData;

        if (forceBlankProduction || configuration.LOAD_BLANK_PRODUCTION == false) {
            if (audioToolUtils.isAudioTool())
                xmlData = audioProduction.data; // should create a separate xml for testing audio tool
            else
                xmlData = newProductionData.data;

            xmlData = this.removeWrongNumbers(xmlData);
        }

        this.executeLoadingActions(xmlData)
            .then(() => {
                store.dispatch(sessionActions.setAppReady());
            });
    },
    loadInitialData() {
        const store = storeManager.getStore();

        if (appParameters.context == modeType.EXPORT_PLAYER || appParameters.context == modeType.EXPORT_AUDIO_PLAYER) {
            apiServiceUtils.executeSafeApiCall(this.loadContent.bind(this));
            return;
        }

        if (appParameters.context == modeType.DOWNLOAD) {
            store.dispatch(sessionActions.setAppReady());
            return;
        }

        if (sessionUtils.isLoginWithToken())
            return;

        if (appParameters.isPrintMode() == true) {
            this.loadContent();
            return;
        }

        if (apiServiceUtils.isWrong() == true)
            return;

        audioUtils.getVisitedAlerts();

        const contentItemId = appParameters.getContentItemId();

        if (contentItemId == -1) { // create a new production from Exercises
            this.executeLoadingActions(undefined)
                .then(() => {
                    store.dispatch(sessionActions.setAppReady());
                });
        } else { // open a saved production or PLAYER
            apiServiceUtils.executeSafeApiCall(this.loadContent.bind(this));
        }
    },
    loadContent() {
        if (appParameters.isExternVideo) {
            const store = storeManager.getStore();
            store.dispatch(sessionActions.setAppReady());

            return;
        }

        apiService.hasAccess(appParameters.contentItemId, appParameters.contentRevisionId) // check if the user has access
            .then(response => {
                if (response.access == true) {
                    this.loadContentCall();
                } else {
                    // No access alert
                    apiServiceUtils.showNoAccessAlert();
                    return;
                }
            });
    },
    loadContentCall() {
        const store = storeManager.getStore();

        var submitId = appParameters.submitId;

        if (appParameters.context != 'edit' && appParameters.context != modeType.AUDIO_TOOL)
            submitId = -1;

        apiService.loadCartoonistContent(appParameters.contentRevisionId, appParameters.contentItemId, submitId)
            .then(content => {
                if (content.data == '') { // create a new production from Exercises
                    this.executeLoadingActions(undefined)
                        .then(() => {
                            store.dispatch(sessionActions.setAppReady());
                        });

                    return;
                } else
                    return this.executeLoadingActions(content.data);
            })
            .then(() => {
                store.dispatch(sessionActions.setAppReady());
            });
    },
    removeBlankSlides(content) {
        if (content && content.indexOf(',{}') != -1)
            return content.replace(',{}', '');
        else
        if (content && content.indexOf('{},') != -1)
            return content.replace('{},', '');
        else
            return content;
    },
    removeWrongNumbers(content) {
        for (var i=0; i<5; i++) {
            if (content && content.indexOf('e+45') != -1)
                content = content.replace('e+45', '');

            if (content && content.indexOf('e-45') != -1)
                content = content.replace('e-45', '');
        }

        return content;
    },
    executeLoadingActions(content) {
        if (content != undefined)
            content = unescape(content);

        content = this.removeBlankSlides(content);
        content = this.removeWrongNumbers(content);

        appParameters.checkType(content);

        const store = storeManager.getStore();
        const currentSlide = 0;

        if (audioToolUtils.isAudioTool()) {
            return Promise.all([
                store.dispatch(loadAudioProduction(content)),
                store.dispatch(setCurrentSlide(currentSlide)),
                playController.prepareAudioTool()
            ]).then(() => {
                if (audioToolUtils.isAudioPlayer()) {
                    return;
                } else
                    return zipLoader.loadAudioClipartJSON();
            });
        } else {
            if (appParameters.isNewCartoonist == true) {
                if (appParameters.context != modeType.EXPORT_PLAYER && appParameters.context != modeType.EXPORT_AUDIO_PLAYER)
                    playController.updateAudioElements();

                return Promise.all([
                    store.dispatch(loadNewProduction(content)),
                    store.dispatch(setCurrentSlide(currentSlide))
                ]).then(() => {
                    return zipLoader.loadData('cartoonist');
                });

            } else {
                return Promise.all([
                    store.dispatch(contentXMLLoaded(content)),
                    store.dispatch(loadOldProduction()),
                    store.dispatch(setCurrentSlide(currentSlide))
                ]).then(() => {
                    return zipLoader.loadData('cartoonist');
                });
            }
        }
    }
};

export default dataLoader;



/** WEBPACK FOOTER **
 ** ./src/DataLoader.js
 **/